<template>
  <div class="home" v-if="label">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{label.titles.title}}</h1>
          <p class="subtitle">{{label.titles.subtitle}}</p>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-vertical">
        <div
          v-for="(msg, index) in homeMessages"
          :key="index"
          :class="`notification ${msg.type || 'is-info'}`"
          style="white-space: pre-line;"
        >
          {{ msg.text }}
        </div>

          <div v-if="this.$route.query.redirectError" class="notification is-warning">Veuillez vous connecter pour accéder aux fonctionnalités de MyConso</div>
          <div v-if="alert.message" :class="`notification ${alert.type}`">{{ alert.message }}</div>

    <div class="modal" v-if="showEmailVerifiedModal" :class="{ 'is-active': showEmailVerifiedModal }">
      <div class="modal-background" @click="showEmailVerifiedModal = false"></div>
      <div class="modal-content">
        <div class="box has-text-centered">
          <p class="title is-5">Votre compte a bien été validé.</p>
          <p>Vous pouvez maintenant vous connecter.</p>
          <br>
          <button class="button is-primary" @click="showEmailVerifiedModal = false">OK</button>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showEmailVerifiedModal = false"></button>
    </div>
          <!-- <div class="tile is-parent" v-if="alert.message">
            <div class="tile is-child notification" :class="alert.type">{{ alert.message }}</div>
          </div> -->
          <!-- <div class="tile is-parent" v-if="this.$route.query.confirmEmailError">
            <div class="tile is-child notification is-warning">
              <span>{{alerts.confirmEmailError}}</span>
              (<a @click="handleReverify">{{label.buttons.resendEmail}}</a>)
            </div>
          </div> -->
          <!-- <div class="tile is-parent" v-if="this.$route.query.adminError">
            <div class="tile is-child notification is-danger">{{label.texts.needAdmin}}</div>
          </div> -->
          <div class="tile is-parent">
            <div class="tile is-child box ms-intro">
              <p>{{label.texts.homeText}}</p>
            </div>
          </div>
          <div class="tile">
            <div class="tile is-parent ms-button">
              <router-link to="/profile/pods" class="tile is-child box box-link">
                <h2 class="title">
                  <awesome-icon icon='bolt'/> Gérer mes points d'accès
                </h2>
                <p>Encoder une demande d'accès à mon point. Cette étape est nécessaire pour avoir des données à visualiser</p>
              </router-link>
            </div>

            <div class="tile is-parent ms-button">
              <router-link to="/data" class="tile is-child box box-link">
                <h2 class="title">
                  <awesome-icon icon="chart-bar"/> {{label.buttons.dataTitle}}
                </h2>
                <p>{{label.buttons.dataText}}</p>
              </router-link>
            </div>
            <!-- <div class="tile is-parent ms-button">
              <router-link to="/comparison" class="tile is-child box box-link">
                <h2 class="title">
                  <awesome-icon icon="chart-pie"/> {{label.buttons.compareTitle}}
                </h2>
                <p>{{label.buttons.compareText}}</p>
              </router-link>
            </div> -->
            <div class="tile is-parent ms-button">
              <router-link to="/profile" class="tile is-child box box-link">
                <h2 class="title">
                  <awesome-icon icon="tasks"/> {{label.buttons.profileTitle}}
                </h2>
                <p>{{label.buttons.profileText}}</p>
              </router-link>
            </div>
          </div>

          <!-- explication et photos compteurs smarts -->
          <div class="tile is">
          <div class="tile is-child box box-link ms-button has-text-centered">
            <h2 class="title is-flex is-justify-content-center">
              <awesome-icon icon='camera' /> <span style="margin-left: 6px;">Compteurs communicants</span>
            </h2>
            <p style="margin-bottom: 1rem; font-weight: 700; color: rgb(255,84,71);" class="is-flex is-justify-content-center">
              Ce portail est réservé aux utilisateurs équipés de compteurs communicants. Pour accéder aux fonctionnalités du portail, vous devez disposer d’un compteur similaire à ceux illustrés sur les images suivantes :
            </p>
            <p class="is-flex is-justify-content-center" style="flex-wrap: wrap;">
              <img style="max-width: 100%; max-height: 25rem;" src="https://arewal-myconso-public.s3.eu-west-1.amazonaws.com/arewal_photo_compteur_gen_1.png" alt="">
              <img style="max-width: 100%; max-height: 25rem; margin-left: 10px;" src="https://arewal-myconso-public.s3.eu-west-1.amazonaws.com/arewal_photo_compteur_gen_2.png" alt="">
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { homeMessageService } from "../services/homeMessage.service";

export default {
  data() {
    return {
      homeMessages: [],
      showEmailVerifiedModal: false
    }
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState({ alert : state => state.alert }),
    ...mapState({ alerts: state => state.labels.alerts }),
    ...mapState({ label: state => state.labels.home }),
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    // ...mapActions("account", ["reverify"]),
    // handleReverify() {
    //   this.reverify({ email: this.user.email })
    // }
  },
  async created() {
    this.getLabel({ view: 'home' })
    this.homeMessages = await homeMessageService.getHomeMessages()
    if (this.$route.query.success === 'true' && this.$route.query.code === 'success') {
      this.showEmailVerifiedModal = true
    }
  }
}
</script>